import {
  LinkProps,
  Breadcrumbs as MUIBreadcrumbs,
  Link as MUILink,
  Typography,
} from "@mui/material";
import { FC } from "react";
import { Params, Link as ReactRouterLink, useMatches } from "react-router-dom";

interface RouteMatch {
  id: string;
  pathname: string;
  params: Params;
  data: unknown;
  handle: unknown;
}

interface HandleType {
  crumb: (params?: Params) => React.ReactNode;
}

export const Link: FC<LinkProps> = (props) => {
  return (
    <MUILink
      {...props}
      component={ReactRouterLink}
      to={props.href ?? "#"}
      underline="hover"
      color="inherit"
    />
  );
};

const Breadcrumbs = () => {
  const matches: RouteMatch[] = useMatches();
  const crumbs = matches
    .filter((match) => match.handle)
    .map((match) => (match.handle as HandleType).crumb(match.params));

  return (
    <MUIBreadcrumbs aria-label="breadcrumb">
      {crumbs.map((crumb, index) => {
        return <Typography key={index}>{crumb}</Typography>;
      })}
      ;
    </MUIBreadcrumbs>
  );
};

export default Breadcrumbs;
